/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Mon Oct 28 2024
 **/

import { PropsWithChildren } from "react";
import { Maybe, SwitchCase } from "@/frameworks/libraries/components";
import { Properties } from "@/frameworks/libraries/properties";

import EncourageSignupPanel from "./EncourageSignupPanel";

type GuestCheckProps = {
	fallbackType: "signupPanel";
	panelType: "MEETING" | "PEOPLE" | "CHAT" | "CALL";
	condition?: boolean;
};

export default function GuestCheck({
	children,
	fallbackType,
	panelType,
	condition
}: PropsWithChildren<GuestCheckProps>) {
	const conditionDisplay = condition ?? !Properties.property.isGuest;

	return (
		<Maybe test={conditionDisplay}>
			{children}
			<Maybe.Fallback>
				<SwitchCase
					condition={fallbackType}
					cases={{
						signupPanel: <EncourageSignupPanel panelType={panelType} />
					}}
				/>
			</Maybe.Fallback>
		</Maybe>
	);
}
